// Error Status
export const SET_ERROR_STATE = 'SET_ERROR_STATE';
